import React from 'react'

type InputProps = {
  value: string
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void
  disabled?: boolean
  error?: string
  maxLength?: number
  type?: React.HTMLInputTypeAttribute
  placeholder?: string
  label?: string
  name?: string
  autoFocus?: boolean
  rightIcon?: React.ReactNode
  inputMode?: React.HTMLAttributes<HTMLInputElement>['inputMode']
  onRightIconClick?: () => void
}

export const Input: React.FC<InputProps> = ({
  value,
  onChange,
  disabled = false,
  error,
  maxLength,
  type = 'text',
  placeholder,
  label,
  name,
  autoFocus = false,
  rightIcon,
  onRightIconClick,
  onBlur,
  inputMode,
}) => (
  <div className="flex w-full flex-col gap-1">
    {label && (
      <label htmlFor={name} className="text-sm font-medium text-gray-700">
        {label}
      </label>
    )}
    <div className={`relative flex w-full items-center`}>
      <input
        id={name}
        name={name}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        disabled={disabled}
        maxLength={maxLength}
        type={type}
        placeholder={placeholder}
        inputMode={inputMode}
        autoFocus={autoFocus}
          {...(error
            ? {
                'aria-invalid': 'true',
                'aria-describedby': name ? `${name}-error` : undefined,
              }
            : {})}
        className={`h-[55px] w-full rounded border px-3 py-2 text-base transition-colors duration-150 ${
          rightIcon ? 'pr-12' : ''
        } ${
          error ? 'border-red-500 ring-red-200' : 'border-gray-700'
        } disabled:bg-gray-100`}
      />
      {rightIcon && (
        <button
          type="button"
          onClick={onRightIconClick}
          className="absolute right-3 flex items-center justify-center text-gray-500 hover:text-gray-700 focus:outline-none"
          tabIndex={-1}
        >
          {rightIcon}
        </button>
      )}
    </div>
    {error && (
      <div
        id={name ? `${name}-error` : undefined}
        className="text-xs font-medium text-red-600"
      >
        {error}
      </div>
    )}
  </div>
)
